export default __webpack_public_path__ + "static/media/qt-icon.78bc71cb.svg";